
function Filtros(props) {
  return (
    <div className="filtros">
      {/* <div className="filtro">
        <label>Ano</label>
        <select id="filtroAno"><option value="0">...</option></select>
      </div>
      <div className="filtro">
        <label>Destino</label>
        <select id="filtroDestino"><option value="0">...</option></select>
      </div> */}
      {props.children}
    </div>
  )
}

export default Filtros;
